import { sceneHandleGeometry, sceneObjectHit } from '../services/mapSceneGeometry'
import { automaticBridgeSegments } from '../services/mapCityScene'
import { isometricSettingsError } from '../services/mapIsometricSettings'
export default {
  data () { return { sceneEdit:null, sceneCursor:null, sceneDrag:null } },
  computed: {
    sceneDrawingActive () { return !!this.sceneEdit?.active && !this.readOnly },
    sceneResizingActive () { return !!this.sceneDrag && !this.readOnly },
    pendingSceneChanges () { return (!!this.sceneEdit?.pending || !!this.sceneDrag) && !this.readOnly },
    sceneCanResize () { return this.editorTab==='layers'&&!this.readOnly&&!this.saving&&!this.templateApplying&&!this.sceneDrawingActive&&!!this.sceneEdit?.preview&&['roads','bridges','waterBodies'].includes(this.sceneEdit.section) },
    sceneHandleRadius () { return 8/Math.max(.05,this.mapViewportWidth*this.mapZoom/this.mapWidth) },
    sceneDisplayTemplate () {
      const template=this.previewTemplate,edit=this.sceneEdit
      if(!edit?.preview)return template
      if(edit.automatic){
        const siblings=automaticBridgeSegments(template).filter(item=>item.roadIndex===edit.automatic.roadIndex&&item.id!==edit.automatic.id).map(({roadIndex,...item})=>({...item,id:'automatic-preview-'+item.id,_automaticSource:{...item,roadIndex}}))
        return {...template,roads:template.roads.map((road,index)=>index===edit.automatic.roadIndex?{...road,bridge:false}:road),bridges:[...(template.bridges||[]),...siblings,edit.preview]}
      }
      const items=(template[edit.section]||[]).slice()
      if(edit.index>=0)items.splice(edit.index,1,edit.preview);else items.push(edit.preview)
      return {...template,[edit.section]:items}
    },
    sceneSketch () {
      const edit=this.sceneEdit
      if(this.sceneDrag){const drag=this.sceneDrag;return {kind:drag.kind,a:drag.handle==='a'?drag.point:drag.fixed,b:drag.handle==='b'?drag.point:drag.fixed}}
      if(this.sceneDrawingActive&&edit.points.length)return {kind:edit.section,a:edit.points[0],b:this.sceneCursor}
      const p=edit?.preview;if(!p)return null
      return {kind:edit.section,a:{x:p.x1??p.x,y:p.y1??p.y},b:['roads','bridges'].includes(edit.section)?{x:p.x2,y:p.y2}:edit.section==='waterBodies'?{x:p.x+p.width,y:p.y+p.height}:null}
    }
  },
  watch: { mapPanMode(value){if(value)this.stopSceneDrawing()} },
  beforeDestroy () { this.releaseSceneCapture() },
  methods: {
    handleSceneMapClick (event) {
      const config=this.$refs.sceneConfig
      if(this.editorTab!=='layers'||!config)return false
      if(config.section==='style'&&(this.drawing||this.pointPicking||this.schemeSelecting))return false
      if(this.saving||this.loading||this.templateApplying||this.mapPanMode||this.sceneDrag)return true
      const point=this.sceneEventPoint(event)
      if(!point)return true
      // 直接读取子表单的同步状态，第二点或连续点击不依赖异步watch回传。
      if(config.mapDrawing&&!this.readOnly){config.acceptMapPoint(point.x,point.y);return true}
      const svg=event.currentTarget?.tagName?.toLowerCase()==='svg'?event.currentTarget:event.target?.closest?.('svg'),matrix=svg?.getScreenCTM()
      const scale=matrix?Math.min(Math.hypot(matrix.a,matrix.b),Math.hypot(matrix.c,matrix.d)):1
      const template=this.sceneDisplayTemplate,hit=sceneObjectHit(template,point,this.layerSwitches,6/Math.max(.001,scale),automaticBridgeSegments(template))
      if(!hit)return config.section!=='style'
      const ownPreview=hit.kind===config.section&&config.editState.preview&&hit.item.id===config.editState.preview.id
      if(ownPreview)return true
      const selected=config.selectMapItem(hit.kind,hit.item._automaticSource||hit.item,hit.index,hit.automatic||!!hit.item._automaticSource)
      const afterSelect=accepted=>{if(accepted&&!this._isDestroyed){
        this.cancelDraw();this.pointPicking=false;this.schemeSelecting=false
        this.$nextTick(()=>{const pane=this.$refs.editorScroll,panel=this.$el.querySelector('.map-scene-config');if(pane&&panel)pane.scrollTop+=panel.getBoundingClientRect().top-pane.getBoundingClientRect().top})
      }}
      if(selected&&typeof selected.then==='function')selected.then(afterSelect);else afterSelect(selected)
      return true
    },
    receiveSceneState (value) { const previous=this.sceneEdit;if(this.sceneDrag&&(value?.section!==this.sceneDrag.kind||value?.preview?.id!==(this.sceneDrag.original.id||'scene-editor-preview'))){this.releaseSceneCapture();this.sceneDrag=null}this.sceneEdit=value;if(!value?.active)this.sceneCursor=null;if(previous?.pending&&!value?.pending&&this.isError&&this.message.startsWith(previous.kindName+'仍在编辑预览中')){this.message='';this.isError=false} },
    async startSceneDrawing (kind) {
      if(this.readOnly||this.saving||this.loading||this.templateApplying||!this.checkPointApplied()||!await this.applyGridDimensions())return
      this.stopMapInteraction();if(this.editorTab!=='layers')this.openEditorTab('layers');this.mapPanMode=false
      this.layerSwitches[{roads:'ROAD',bridges:'ROAD',waterBodies:'WATER',landmarks:'LANDMARKS'}[kind]]=true
      this.sceneCursor=null;this.$refs.sceneConfig?.startDrawing();this.$nextTick(()=>this.$refs.mapViewport?.focus({preventScroll:true}))
    },
    stopSceneDrawing () { this.stopSceneResize(true);this.$refs.sceneConfig?.stopPicking();this.sceneCursor=null },
    startSceneResize (handle,event) {
      if(!this.sceneCanResize||event.button!==0)return
      const config=this.$refs.sceneConfig,sketch=this.sceneSketch
      if(!config||!sketch?.b)return
      this.cancelDraw();this.pointPicking=false;this.schemeSelecting=false;this.mapPanMode=false
      this.layerSwitches[config.section==='waterBodies'?'WATER':'ROAD']=true
      const keys=config.section==='waterBodies'?['x','y','width','height']:['x1','y1','x2','y2']
      this.sceneDrag={kind:config.section,handle,original:{...config.form},values:Object.fromEntries(keys.map(key=>[key,config.form[key]])),located:config.mapLocated,fixed:{...(handle==='a'?sketch.b:sketch.a)},point:{...(handle==='a'?sketch.a:sketch.b)},pointerId:event.pointerId,element:event.currentTarget,screen:{x:event.clientX,y:event.clientY},moved:false,valid:true}
      try { event.currentTarget.setPointerCapture?.(event.pointerId) } catch (_) {}
      this.$refs.mapViewport?.focus({preventScroll:true})
    },
    resizeScenePointer (event) {
      const drag=this.sceneDrag
      if(!drag||event.pointerId!==drag.pointerId)return
      if(!drag.moved&&Math.hypot(event.clientX-drag.screen.x,event.clientY-drag.screen.y)<2)return
      drag.moved=true
      const point=this.sceneEventPoint(event)
      if(!point)return
      const geometry=sceneHandleGeometry(drag.kind,drag.original,drag.handle,point)
      drag.point=point;drag.valid=!!geometry
      if(geometry)this.$refs.sceneConfig?.previewGeometry(geometry)
    },
    releaseSceneCapture () {
      const drag=this.sceneDrag
      if(drag?.element?.hasPointerCapture?.(drag.pointerId))drag.element.releasePointerCapture(drag.pointerId)
    },
    stopSceneResize (cancel=false) {
      const drag=this.sceneDrag
      if(!drag)return
      this.releaseSceneCapture();this.sceneDrag=null
      if(cancel||!drag.valid)this.$refs.sceneConfig?.restoreGeometry(drag.values,drag.located)
      if(!cancel&&!drag.valid&&this.$refs.sceneConfig)this.$refs.sceneConfig.error=drag.kind==='waterBodies'?'水体范围的宽度和高度须大于0，本次拖动已还原':'两端不能重合，本次拖动已还原'
    },
    endSceneResize (event) { if(this.sceneDrag&&event.pointerId===this.sceneDrag.pointerId){this.resizeScenePointer(event);this.stopSceneResize()} },
    nudgeSceneHandle (handle,event) {
      if(!this.sceneCanResize)return
      const direction={ArrowLeft:[-1,0],ArrowRight:[1,0],ArrowUp:[0,-1],ArrowDown:[0,1]}[event.key]
      if(!direction)return
      event.preventDefault();event.stopPropagation()
      const point=this.sceneSketch[handle],step=event.shiftKey?10:1,config=this.$refs.sceneConfig
      const target={x:Math.max(0,Math.min(this.mapWidth,point.x+direction[0]*step)),y:Math.max(0,Math.min(this.mapHeight,point.y+direction[1]*step))}
      const geometry=sceneHandleGeometry(config.section,config.form,handle,target)
      if(geometry)config.previewGeometry(geometry)
    },
    sceneEventPoint (event) {
      if (event.target?.closest?.('[data-isometric-editor]') || event.currentTarget?.dataset?.isometricEditor) return this.$refs.isoEditor?.eventPoint(event) || null
      const svg=event.currentTarget?.tagName?.toLowerCase()==='svg'?event.currentTarget:event.target?.closest?.('svg'),matrix=svg?.getScreenCTM()
      if(!matrix)return null
      const point=svg.createSVGPoint();point.x=event.clientX;point.y=event.clientY
      const local=point.matrixTransform(matrix.inverse())
      return {x:Math.max(0,Math.min(this.mapWidth,Number(local.x.toFixed(2)))),y:Math.max(0,Math.min(this.mapHeight,Number(local.y.toFixed(2))))}
    },
    moveScenePointer (event) { if(this.sceneDrawingActive)this.sceneCursor=this.sceneEventPoint(event) },
    checkSceneApplied () {
      const appearanceError = isometricSettingsError(this.sceneSettings)
      if (appearanceError) { this.openEditorTab('city'); this.fail({ message: appearanceError }); return false }
      if(!this.pendingSceneChanges)return true
      if(this.editorTab!=='layers')this.openEditorTab('layers');this.mapConfigCollapsed=false
      this.fail({message:this.sceneEdit.kindName+'仍在编辑预览中，请先点击“新增'+this.sceneEdit.kindName+' / 应用'+this.sceneEdit.kindName+'修改”，或重置表单后再继续'})
      return false
    }
  }
}
